import { API_ENDPOINTS } from '../config/api'; // Usar API_ENDPOINTS en lugar de baseURL

let usuario = null;

export const fetchUsuario = async () => {
    try {
        const response = await fetch(API_ENDPOINTS.userLogued, {
            method: 'POST',
            credentials: 'include',
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        usuario = await response.json();
    } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
        usuario = null; // Restablecer usuario si hay error
    }
};

export const getUsuario = () => {
    return usuario; // Devuelve los datos del usuario
};
